import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import styles from './MobileTabHeader.module.scss';

interface MobileTabHeaderProps {
  icon: IconDefinition;
  label: string;
  active: boolean;
}

const MobileTabHeader: React.FC<MobileTabHeaderProps> = ({
  icon,
  label,
  active,
}) => {
  return (
    <div
      className={`${styles.tabHeader} ${active ? styles.active : styles.unActive}`}
    >
      <FontAwesomeIcon icon={icon} className={styles.icon} />
      <span className={styles.label}>{label}</span>
    </div>
  );
};

export default MobileTabHeader;
